import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';

class ShopCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: '',
      address: '',
      companyId: '',
      phoneNumber: '',
      nameError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNameChange = (event, name) => this.setState({name, nameError: ''})
  handleAddressChange = (event, address) => this.setState({address})
  handleCompanyIdChange = (event, companyId) => this.setState({companyId})
  handlePhoneNumberChange = (event, phoneNumber) => this.setState({phoneNumber})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('shop.nameRequired')});
      return false;
    }
    return true;
  }

  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }

  handleSave = () => {
    const {firebase} = this.props;

    if (!this.validateName()) return;

    const shopkeeper = {
      info: {
        name: this.state.name,
        address: this.state.address,
        companyId: this.state.companyId,
        phoneNumber: this.state.phoneNumber,
      }
    };

    firebase.database().ref('shopkeepers/').push(shopkeeper).then((data) => {
      firebase.database().ref('shopkeepersList/' + data.key).set(shopkeeper.info.name);
    });

    this.handleClose();
  }
  render() {

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title={t('shop.create')}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
        >
          <TextField
            hintText={t('shop.name')}
            floatingLabelText={t('shop.name')}
            onBlur={this.validateName}
            errorText={this.state.nameError}
            onChange={this.handleNameChange}
            value={this.state.name}
            />
          <br />
          <TextField
            hintText={t('shop.address')}
            floatingLabelText={t('shop.address')}
            onChange={this.handleAddressChange}
            value={this.state.address}
          />
          <br />
          <TextField
            hintText={t('shop.companyId')}
            floatingLabelText={t('shop.companyId')}
            onChange={this.handleCompanyIdChange}
            value={this.state.companyId}
          />
          <br />
          <TextField
            hintText={t('shop.phoneNumber')}
            floatingLabelText={t('shop.phoneNumber')}
            onChange={this.handlePhoneNumberChange}
            value={this.state.phoneNumber}
          />
          <br />
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ShopCreate);



// WEBPACK FOOTER //
// ./src/Admin/ShopCreate.js